// @flow
import React from 'react';
import i18n from '../../../../i18n/i18n.js';

type Props = {
    lng: string,
};

const ProtectedBy = ({ lng }: Props) => (
    <div id="inplayer-branded">
        <span>{i18n.t('preview_protected_by_inplayer', { lng })}</span>
        <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://inplayer.com"
            id="inplayer-logo"
            title="InPlayer"
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.8 59.8">
                <title>ip-icon-blue</title>
                <g style={{ isolation: 'isolate' }}>
                    <g id="Layer_1" data-name="Layer 1">
                        <polygon
                            points="44.85 4.01 59.8 29.9 44.85 55.8 14.95 55.8 0 29.9 14.95 4.01 44.85 4.01"
                            style={{ fill: '#2a4d8e' }}
                        />
                        <polygon
                            points="14.95 55.8 29.9 29.9 14.95 4.01 0 29.9 14.95 55.8"
                            style={{
                                fill: '#00aad2',
                                opacity: '0.15',
                            }}
                        />
                        <polygon
                            points="59.8 29.9 29.9 29.9 14.95 55.8 44.85 55.8 59.8 29.9"
                            style={{
                                fill: '#272b38',
                                opacity: '0.15',
                                mixBlendMode: 'multiply',
                            }}
                        />
                        <circle
                            cx="29.9"
                            cy="29.9"
                            r="14.95"
                            style={{
                                fill: '#449bbc',
                                opacity: 0,
                            }}
                        />
                        <circle
                            cx="29.9"
                            cy="29.9"
                            r="29.9"
                            style={{ fill: 'none' }}
                        />
                        <circle
                            cx="29.9"
                            cy="29.9"
                            r="29.9"
                            style={{ fill: 'none' }}
                        />
                        <polygon
                            points="40.9 44.85 22.43 42.85 14.68 31.86 22.43 16.95 40.33 18.17 44.85 29.9 40.9 44.85"
                            style={{
                                fill: '#272b38',
                                opacity: '0.35000000000000003',
                                mixBlendMode: 'multiply',
                            }}
                        />
                        <circle
                            cx="29.9"
                            cy="29.9"
                            r="14.95"
                            style={{
                                fill: '#449bbc',
                                opacity: 0,
                            }}
                        />
                        <polygon
                            points="37.38 42.85 22.43 42.85 14.95 29.9 22.43 16.95 37.38 16.95 44.85 29.9 37.38 42.85"
                            style={{ fill: '#00aae6' }}
                        />
                        <polygon
                            points="33.64 36.37 22.43 42.85 22.43 29.9 22.43 16.95 33.64 23.43 44.85 29.9 33.64 36.37"
                            style={{ fill: '#fff' }}
                        />
                    </g>
                </g>
            </svg>
        </a>
    </div>
);

export default ProtectedBy;



// WEBPACK FOOTER //
// ./src/ui/components/Modal/Footer/ProtectedBy.js